import React from "react";

import {
	getTranslatedGameName
} from "@/modules/commonMobile";

import how_to_play_arrow_down from "@/assets/img/mobile/how_to_play_arrow_down.png";
import how_to_play_arrow_up from "@/assets/img/mobile/how_to_play_arrow_up.png";

import { 
	ILanguageType,
	IUserdataType,
} from "@/types/GlobalTypes";
import { isIPhone } from "@/modules/iOSDetection";
import { getBasePcode } from "@/modules/gamePcode";

interface IProps {
	howToPlayPcode: string;
	langdata: ILanguageType;
	userdata: IUserdataType;

	mobile: boolean;
	orientation: string;

	desktop: boolean;

	toggleHowToPlay: (e: any) => void;
	toggleHowToPlayDropdown: (e: any) => void;
	showHowToPlayDropdown: boolean;
	changeHowToPlayPcode: (e: any) => void;

	uniqueGamePcodes: string[];

	nooverlay?: boolean;
}

interface IState {
	//How To Play Page
	HTPP: JSX.Element;
}

export default class PopupHowToPlay extends React.Component<IProps, IState> {
	state = {
		HTPP: null
	};

	loaded: boolean;

	loadHowToPlayPage() {
		const PHTP = this;
		const {
			howToPlayPcode,
			langdata,
			userdata
		} = this.props;
		const basePcode = getBasePcode(howToPlayPcode);

		console.log("lHTPP " + basePcode);

		import("../HowToPlayPages/" + basePcode)
			.then(Module => {
				const defaultModule = (
					React.createElement(Module.default, {
						langdata,
						userdata,
						pcode: basePcode
					})
				);

				PHTP.setState({
					HTPP: defaultModule
				});

				PHTP.loaded = true;
			}).catch(err => {
				console.error("Error on lHTPP:", err);

				PHTP.setState({HTPP: (
					<div>{langdata["txt_no_how_to_play"]}</div>
				)});

				PHTP.loaded = true;
			});
	}

	componentDidMount() {
		this.loadHowToPlayPage();
	}

	componentDidUpdate(prevProps) {
		// console.log(+(new Date()), this.props.howToPlayPcode, prevProps.howToPlayPcode);
		const prevPcode = getBasePcode(prevProps.howToPlayPcode);
		const newPcode = getBasePcode(this.props.howToPlayPcode);

		if (newPcode !== prevPcode)
			this.loaded = false;

		if (!this.loaded)
			this.loadHowToPlayPage();
	}

	render() {
		const {langdata, mobile, desktop, howToPlayPcode} = this.props;
		const HTPP = this.state.HTPP;

		return [
			this.props.nooverlay ? null : (
				<div key="sHTP_0" className={"game-result-history-popup-overlay"}
					onClick={this.props.toggleHowToPlay}>
					{!desktop ? langdata["txt_touch_to_close"] : ""}
				</div>
			),
			<div key="sHTP_1"
				className={
						"how-to-play-panel" +
						(desktop ? " desktop" : "") +
						(mobile ? " sl-single-mobile" : "") +
						(isIPhone() ? " iphone" : "") +
						(" " + this.props.orientation) +
						(" " + howToPlayPcode)
					}>
				<div className="how-to-play-header">
					<div>{langdata["txt_how_to_play"]}</div>

					{ /*onclick shows the drop down*/}
					<div className="game-name"
						onClick={this.props.toggleHowToPlayDropdown}>

						<div>{langdata["txt_game_name_" + getBasePcode(this.props.howToPlayPcode)]}</div>

						{
							this.props.showHowToPlayDropdown ?
							<img className="drop-down-arrow" src={how_to_play_arrow_up} alt="" /> :
							<img className="drop-down-arrow" src={how_to_play_arrow_down} alt="" />
						}
					</div>

					<span className="close" onClick={this.props.toggleHowToPlay}>
						<i className={"sl-ic-close"} />
					</span>
				</div>

				<div className={"how-to-play-drop-down" +
					(this.props.showHowToPlayDropdown ? " active" : "")
				}>
					{
						this.props.uniqueGamePcodes.map(key =>
							<div key={"HTPDD_" + key}
								className={
									key === getBasePcode(this.props.howToPlayPcode) ?
										"active" : ""
								}
								{...{game: key}}
								onClick={this.props.changeHowToPlayPcode}>
								{getTranslatedGameName(langdata, key)}
							</div>
						)
					}
				</div>

				<div className="how-to-play-contents">
					{HTPP ? HTPP : null}
				</div>
			</div>
		];
	}
}